import React from 'react';
import "../style/gcardStyle.css";
import { useTranslation } from "react-i18next";
import { FcGoogle } from "react-icons/fc"; 
import { useSearchParams } from 'react-router-dom';
import EditGcardForm from '../forms/EditGcardForm';
const EditGcard = () => {
   const { t } = useTranslation();
   const [searchParams] = useSearchParams();
     const id = searchParams.get("id");
  return (
    <div className='add_google_card'>
      <h3 className='text-center mb-4'> <FcGoogle/> {t("HEADING.ADDGCARDTITLE")} </h3>
       <EditGcardForm translate={t} cardId={id}/>
    </div>
  )
}

export default EditGcard
